import React from 'react';
import {CircularProgress, Avatar, Box} from '@chakra-ui/react';

interface AvatarUtilizationRingProps {
  percentage: number; // Remaining percentage
  src?: string;
  name?: string;
  size?: number;
}

const getColorScheme = (percentage: number) => {
  if (percentage > 50) return 'green.400';
  if (percentage > 15) return 'orange.400';
  return 'red.400';
};

const AvatarUtilizationRing: React.FC<AvatarUtilizationRingProps> = ({percentage, src, name, size = 44}) => {
  const color = getColorScheme(percentage);

  return (
    <Box
      position="relative"
      w="53px"
      h="53px"
      transition="transform 0.2s"
      _hover={{
        transform: "scale(1.05)"
      }}
    >
      <CircularProgress
        value={percentage}
        size="53px"
        thickness="12px"
        color={color}
        trackColor="gray.600"
      />
      <Avatar
        size="md"
        name={name}
        src={src}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        border="1px solid transparent"
      />
    </Box>
  );
};

export default AvatarUtilizationRing;